import { Grid } from "@mui/material"
import { DeviceDetails } from "../deviceTypes"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import {
    DeviceDetailsBox,
    DeviceDetailsHeaderBox,
    DeviceDetailsInfoItem,
    DeviceDetailsSectionBoxTable,
} from "./DeviceDetailsDialogElements"

type DeviceDetailsDialogInfoSectionProps = Readonly<{
    deviceDetailsData: DeviceDetails
}>

export function DeviceDetailsDialogInfoSection({ deviceDetailsData }: DeviceDetailsDialogInfoSectionProps) {
    const { name, shop, deviceNumber, serialNumber, hardwareUid } = deviceDetailsData

    return (
        <Grid container gap={5} flexWrap="nowrap">
            <Grid item xs={5}>
                <DeviceDetailsBox>
                    <LocalizedStrict id="device-details-device-info-title" attrs={{ title: true }}>
                        <DeviceDetailsHeaderBox title="Device" />
                    </LocalizedStrict>
                    <DeviceDetailsSectionBoxTable>
                        <LocalizedStrict id="device-details-device-info-name" attrs={{ label: true }}>
                            <DeviceDetailsInfoItem label="Name:">
                                <span>{name ?? "-"}</span>
                            </DeviceDetailsInfoItem>
                        </LocalizedStrict>
                        <LocalizedStrict id="device-details-device-info-shop" attrs={{ label: true }}>
                            <DeviceDetailsInfoItem label="Shop:">{shop?.name ?? "-"}</DeviceDetailsInfoItem>
                        </LocalizedStrict>
                        <LocalizedStrict id="device-details-device-info-device-number" attrs={{ label: true }}>
                            <DeviceDetailsInfoItem label="Device number:">{deviceNumber ?? "-"}</DeviceDetailsInfoItem>
                        </LocalizedStrict>
                    </DeviceDetailsSectionBoxTable>
                </DeviceDetailsBox>
            </Grid>
            <Grid item xs={7}>
                <DeviceDetailsBox>
                    <LocalizedStrict id="device-details-identification-info-title" attrs={{ title: true }}>
                        <DeviceDetailsHeaderBox title="Identification" />
                    </LocalizedStrict>
                    <DeviceDetailsSectionBoxTable>
                        <LocalizedStrict id="device-details-identification-info-serial-number" attrs={{ label: true }}>
                            <DeviceDetailsInfoItem label="Serial number:">
                                <span>{serialNumber ?? "-"}</span>
                            </DeviceDetailsInfoItem>
                        </LocalizedStrict>
                        <LocalizedStrict id="device-details-identification-info-hardware-id" attrs={{ label: true }}>
                            <DeviceDetailsInfoItem label="Hardware ID:">{hardwareUid ?? "-"}</DeviceDetailsInfoItem>
                        </LocalizedStrict>

                        {/* No data in the request */}
                        <LocalizedStrict id="device-details-identification-info-acquirer" attrs={{ label: true }}>
                            <DeviceDetailsInfoItem label="Card terminal acquirer name:">{"-"}</DeviceDetailsInfoItem>
                        </LocalizedStrict>
                    </DeviceDetailsSectionBoxTable>
                </DeviceDetailsBox>
            </Grid>
        </Grid>
    )
}
